var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path2, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _circle, _mask, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitingVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 296,
    viewBox: "0 0 200 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 296,
    rx: 16,
    fill: "#F8F9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 104,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 35,
    width: 93,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 35,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 56,
    width: 91,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 49,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 49,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 49,
    width: 36,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 31,
    width: 33,
    height: 33,
    rx: 3,
    stroke: "#CFD4DA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146 46.5L154.5 54L175.5 33",
    stroke: "#3681D3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 109,
    width: 104,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 102,
    width: 93,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 102,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 123,
    width: 91,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 116,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 116,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 116,
    width: 36,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 98,
    width: 33,
    height: 33,
    rx: 3,
    stroke: "#CFD4DA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146 113.5L154.5 121L175.5 100",
    stroke: "#3681D3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 176,
    width: 104,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 169,
    width: 93,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 169,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 190,
    width: 91,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 183,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 183,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 183,
    width: 36,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 165,
    width: 33,
    height: 33,
    rx: 3,
    stroke: "#CFD4DA",
    strokeWidth: 2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 243,
    width: 104,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 236,
    width: 93,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 236,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 257,
    width: 91,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 250,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 250,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 250,
    width: 36,
    height: 2,
    rx: 1,
    fill: "#CFD4DA"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 232,
    width: 33,
    height: 33,
    rx: 3,
    stroke: "#CFD4DA",
    strokeWidth: 2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 109.161,
    y: 201.719,
    width: 8.68374,
    height: 65.5263,
    rx: 4,
    transform: "rotate(-47.485 109.161 201.719)",
    fill: "#EEF6FF",
    stroke: "#00244B",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 77,
    cy: 162,
    r: 46,
    fill: "#2065B1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-38-outside-1_2059_47239",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 108,
    width: 108,
    height: 108,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 23,
    y: 108,
    width: 108,
    height: 108
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 214C105.719 214 129 190.719 129 162C129 133.281 105.719 110 77 110C48.2812 110 25 133.281 25 162C25 190.719 48.2812 214 77 214ZM77 209C102.957 209 124 187.957 124 162C124 136.043 102.957 115 77 115C51.0426 115 30 136.043 30 162C30 187.957 51.0426 209 77 209Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 214C105.719 214 129 190.719 129 162C129 133.281 105.719 110 77 110C48.2812 110 25 133.281 25 162C25 190.719 48.2812 214 77 214ZM77 209C102.957 209 124 187.957 124 162C124 136.043 102.957 115 77 115C51.0426 115 30 136.043 30 162C30 187.957 51.0426 209 77 209Z",
    fill: "#EEF6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127 162C127 189.614 104.614 212 77 212V216C106.823 216 131 191.823 131 162H127ZM77 112C104.614 112 127 134.386 127 162H131C131 132.177 106.823 108 77 108V112ZM27 162C27 134.386 49.3858 112 77 112V108C47.1766 108 23 132.177 23 162H27ZM77 212C49.3858 212 27 189.614 27 162H23C23 191.823 47.1766 216 77 216V212ZM122 162C122 186.853 101.853 207 77 207V211C104.062 211 126 189.062 126 162H122ZM77 117C101.853 117 122 137.147 122 162H126C126 134.938 104.062 113 77 113V117ZM32 162C32 137.147 52.1472 117 77 117V113C49.938 113 28 134.938 28 162H32ZM77 207C52.1472 207 32 186.853 32 162H28C28 189.062 49.938 211 77 211V207Z",
    fill: "#00244B",
    mask: "url(#path-38-outside-1_2059_47239)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingVerification);
export default __webpack_public_path__ + "static/media/waiting-verification.9faa77882196f707bd2c930023ce0e38.svg";
export { ForwardRef as ReactComponent };